const LOCAL_STORAGE_POT = 'pharmedistore_pots'

const POT_MANAGER = {
  set: value => {
    POT_MANAGER._set(value)
  },
  get: () => {
    if (typeof window !== 'undefined') {
      const value = window.localStorage.getItem(LOCAL_STORAGE_POT)
      return value === 'true'
    }
  },

  // private method
  _set: value => {
    if (typeof window !== 'undefined')
      window.localStorage.setItem(LOCAL_STORAGE_POT, value ? 'true' : 'false')
  },

  reset: () => {
    if (typeof window !== 'undefined') window.localStorage.removeItem(LOCAL_STORAGE_POT)
  },

  checkProfile: profile => {
    if (profile && !profile.groupSubscriptionActive) {
      POT_MANAGER.set(false)
    }
  },
}

export default POT_MANAGER
